/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class RouteParam {
    static readonly AssessmentId = 'assessmentId';
    static readonly TestId = 'testId';
}
